import gql from 'graphql-tag';

export class ContentTagMutations {
  static createCategory = gql`
    mutation createDealroomResourceTagCategory($payload: CreateDealroomResourceTagCategory!) {
      createDealroomResourceTagCategory(payload: $payload) {
        id
        name
      }
    }
  `;

  static deleteCategory = gql`
    mutation deleteDealroomResourceTagCategory($categoryId: String!) {
      deleteDealroomResourceTagCategory(categoryId: $categoryId)
    }
  `;

  static updateCategory = gql`
    mutation updateDealroomResourceTagCategory(
      $payload: UpdateDealroomResourceTagCategory!
      $categoryId: String!
    ) {
      updateDealroomResourceTagCategory(payload: $payload, categoryId: $categoryId)
    }
  `;

  static createTag = gql`
    mutation createDealroomResourceTag($payload: CreateDealroomResourceTag!, $categoryId: String!) {
      createDealroomResourceTag(payload: $payload, categoryId: $categoryId) {
        id
        name
      }
    }
  `;

  static deleteTag = gql`
    mutation deleteDealroomResourceTag($tagId: String!, $categoryId: String!) {
      deleteDealroomResourceTag(tagId: $tagId, categoryId: $categoryId)
    }
  `;

  static updateTag = gql`
    mutation updateDealroomResourceTag(
      $payload: UpdateDealroomResourceTag!
      $tagId: String!
      $categoryId: String!
    ) {
      updateDealroomResourceTag(payload: $payload, tagId: $tagId, categoryId: $categoryId)
    }
  `;
}
